export const Color = {
  RED: 'red',
  GREEN: 'green',
  BLUE: 'blue',
};

export const AutomatedEmailSending = {
  SendEmailToAllNewApplicantsWhenJobClosesOrArchives: 'SendEmailToAllNewApplicantsWhenJobClosesOrArchives',
};

// Used to determine which backend endpoint to call
export const EmailPurpose = {
  KanbanEmailConfiguration: 'KanbanEmailConfiguration',
  AutomatedEmailSending: 'AutomatedEmailSending',
};

export const JobStatus = {
  Published: 'Published',
  Expired: 'Expired',
  Archived: 'Archived',
  Deleted: 'Deleted',
  Closed: 'Closed',
  Draft: 'Draft',
};

export const UserRole = {
  Owner: 'Owner',
  Editor: 'Editor',
  Partner: 'Partner',
  Viewer: 'Viewer',
};

export const CalendarEventAttendeeType = {
  Applicant: 'Applicant',
  User: 'User',
};

export const KanbanUpdateType = {
  Order: 'Order',
  Visibility: 'Visibility',
};

export const SpinnerLoaderType = {
  FullScreen: 'FullScreen',
  Small: 'Small',
};

export const QuestionType = {
  Normal: 'Normal',
  ForQuestionnaire: 'ForQuestionnaire',
};

export const CompanyStatus = {
  New: 'New',
  WaitingForVerification: 'WaitingForVerification',
  Verified: 'Verified',
  Rejected: 'Rejected',
  Blocked: 'Blocked',
};

export const CreatedBy = {
  System: 'System',
  Applicant: 'Applicant',
  Recruiter: 'Recruiter',
  RecruiterFromGitHub: 'RecruiterFromGitHub',
};

export const StripeProductIds = {
  Coffee: 'prod_Pb94v4FSoUgDwq',
  FiveUsers10Jobs: 'prod_PWq6yhE3vBYag2',
  TenUsers20Jobs: 'prod_PYO139wYjyqJfY',
  FifteenUsersUnJobs: 'prod_PYU96QmpyvYq0K',
  TwentyUsersUnJobs: 'prod_PYUCS0fc8LDD8e',
  TwentyFiveUsersUnJobs: 'prod_PYUGb9NLapNjPZ',
};

export const ModalMode = {
  View: 'View',
  Edit: 'Edit',
  Create: 'Create',
  EditAndCreate: 'EditAndCreate',
};
